// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yvSgttqa4lkDwwb0 {
  width: 240px;
  margin: 121px auto 0;
}
.nXVu0MSMs7IcHHuK {
  width: 223px;
  height: 133px;
  border: 1px dashed #ccc;
  margin-bottom: 16px;
}
.r5r5No9EAGEik9vK {
  font-size: 14px;
  color: #666666;
}
.r5r5No9EAGEik9vK span {
  color: #0095FC;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./app/assets/components/Empty/index.modules.less"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,oBAAA;AACF;AACA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;AACA;EACE,eAAA;EACA,cAAA;AACF;AAHA;EAII,cAAA;EACA,eAAA;AAEJ","sourcesContent":[".wrapper {\n  width: 240px;\n  margin: 121px auto 0;\n}\n.Empty {\n  width: 223px;\n  height: 133px;\n  border: 1px dashed #ccc;\n  margin-bottom: 16px;\n}\n.EmptyText {\n  font-size: 14px;\n  color: #666666;\n  span {\n    color:#0095FC;\n    cursor: pointer;\n\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `yvSgttqa4lkDwwb0`,
	"Empty": `nXVu0MSMs7IcHHuK`,
	"EmptyText": `r5r5No9EAGEik9vK`
};
export default ___CSS_LOADER_EXPORT___;
